import { initializeEditor } from "@/services/apiEditor";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export function useInitEditor(proposal_id, search_type) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (content) =>
      initializeEditor(proposal_id, search_type, content),
    onSuccess: () => {
      queryClient.invalidateQueries([
        "proposalStreaming",
        proposal_id,
        search_type,
      ]);
    },
  });
}
